import { useMemo } from 'react';
import { QuoteInformation, StudyType } from '@app/api';
import { useFormikContext } from 'formik';
import { DurationRangeSelectors } from 'components';
import { DurationSelectors } from '../../components/DurationSelectors';

export const DurationSection = () => {
  const { values } = useFormikContext<Partial<QuoteInformation>>();
  const { studyType } = values;

  const durationSelectorsButtonDurations = useMemo(
    () =>
      studyType === StudyType.UNMODERATED ? [10, 20, 30, 60] : [30, 45, 60],
    [studyType],
  );

  if (studyType === StudyType.MODERATED) {
    return (
      <DurationSelectors
        name="duration"
        buttonDurations={durationSelectorsButtonDurations}
        defaultDuration={20}
      />
    );
  }
  return (
    <DurationRangeSelectors
      name="duration"
      buttonDurations={durationSelectorsButtonDurations}
    />
  );
};
